import { Component, Vue } from 'vue-property-decorator';
import NotificationLevel from '@/core/enums/notificationLevel';

@Component
export default class TranslatesNotificationLevel extends Vue {
    public translateNotificationLevel(notificationLevel: NotificationLevel): string {
        return this.$t(`notification-levels.${notificationLevel}`).toString();
    }
}
